import SubcontractorsTableHelper     from "./subcontractors-table-helper";
import SubcontractorUsersTableHelper from "./subcontractor-users-table-helper";

const SubcontractorHelpers = {
    TableMain  : SubcontractorsTableHelper,
    TableUsers : SubcontractorUsersTableHelper,
}

export default SubcontractorHelpers;